export const phonePattern = '^\\+?\\d+$';
export const emailPattern = '^[\\w._%+-]+@[\\w.-]+\\.[A-Za-z]{2,}$';
